import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Error from '../components/ui/Error';
import Loader from '../components/ui/Loader';
import Navbar from '../components/ui/Navbar';
import Video from '../components/video/Video';
import { useGetVideosQuery } from '../features/videos/videosApi';
import VideoForm from '../components/video/VideoForm';
import { toggleVideoModal } from '../features/videos/videosSlice';
import { Helmet } from 'react-helmet';


function Videos() {
	//Variables
	const dispatch = useDispatch();
	const { data: videos, isLoading, isError } = useGetVideosQuery() || {};

	//States
	const { isVideoModalOpen } = useSelector((state) => state.videos);

	//Functions
	const handleModal = () => {
		dispatch(toggleVideoModal(!isVideoModalOpen))
	}


	//Decide what to render
	let content = null;

	if (isLoading) {
		content = <Loader />
	}
	if (!isLoading && isError) {
		content = <Error message="There was an error occured!" />
	}
	if (!isLoading && !isError && videos.length === 0) {
		content = <div className='text-center'>No Videos Found</div>
	}
	if (!isLoading && !isError && videos.length > 0) {
		content = (
			<div className="overflow-x-auto mt-4">
				<table className="divide-y-1 text-base divide-gray-600 w-full">
					<thead>
						<tr>
							<th className="table-th">Video Title</th>
							<th className="table-th">Description</th>
							<th className="table-th">Action</th>
						</tr>
					</thead>

					<tbody className="divide-y divide-slate-600/50">
						{videos.map((video) => (<Video key={video.id} video={video} />))}
					</tbody>
				</table>
			</div>
		);
	}

	return (
		<>
			<Helmet>
				<title>Videos</title>
			</Helmet>
			<Navbar />
			<section className="py-6 bg-primary">
				<div className="mx-auto max-w-full px-5 lg:px-20">
					<div className="px-3 py-20 bg-opacity-10">
						<div className="w-full flex">
							<button className="btn ml-auto" onClick={handleModal}>Add Video</button>
						</div>
						{content}
					</div>
				</div>
			</section>
			{isVideoModalOpen && <VideoForm />}
		</>
	)
}

export default Videos